import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit {
    public itemsListPayments: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadPayments() {
        this.itemsListPayments = await this.datatask.Post(624);
    }

    private async init() {
        this.loadPayments();
    }

    ngOnInit() {
        this.init();
    }
}
